<div class="container-fluid container--fixed-available-viewport-height">
  <div class="row justify-content-md-center">
    <loading-indicator *ngIf="measurementLoadingInProgress$ | async"></loading-indicator>
  </div>

  <div class="row h-100" *ngIf="ecgAnalysis">
    <div class="h-100 overflow-auto col-md-6 col-md">
      <div id="leftPanel">
        <div class="row">
          <div id="studyId" class="col-9 row pb-4">

            <div
              class="w-100"
              *ngFor="let entry of [
                { label: labelStudyId, value: ecgAnalysis.code },
                { label: labelMeasurementType, value: getMeasurementTypeLabel() | localize},
                { label: labelHospitalName, value: ecgAnalysis.hospitalName },
                { label: labelUniqueId, value: ecgAnalysis.uniqueId },
              ]"
            >
              <span class="strong ps-4">{{ entry.label | localize }}:</span>
              <span class="ps-2">{{ entry.value }}</span>
            </div>

            <div class="w-100" *ngIf="ecgAnalysis.externalAnalysisUrl">
              <span class="strong ps-4">{{ labelExternalAnalysisUrl | localize }}:</span>
              <a data-testId="external-analysis-url" class="ps-2"
                 [href]="ecgAnalysis.externalAnalysisUrl"
                 target="_blank">{{ ecgAnalysis.externalAnalysisUrl }}</a>
            </div>

          </div>
          <div class="col-3 text-end">
            <app-pre-confirm-action-button
              *ngIf="canSkipReport()"
              [testId]="'skip-report-button'"
              [buttonClass]="'btn ' + (isTechnicianAnalysisOnly() ? 'btn-primary' : 'btn-outline-primary')"
              (buttonClick)="skipReport()"
              [buttonLabel]="isTechnicianAnalysisOnly() ? 'analysisLabelButtonFinish' : 'analysisButtonSkipReport'"
              [confirmationLabel]="isTechnicianAnalysisOnly() ? 'analysisLabelButtonFinishConfirm' : 'analysisButtonSkipReportConfirmation'"
              [actionInProgressLabel]="isTechnicianAnalysisOnly() ? 'analysisLabelButtonFinishInProgress' : 'analysisButtonSkipReportInProgress' "
              [buttonState]="skipReportState"
            ></app-pre-confirm-action-button>
          </div>
        </div>
        <div
          *ngIf="isTechnicianAnalysisOnly() && patientDataFields"
          class="col-12 small form-grid form-grid-striped"
        >
          <div class="row">
            <app-form-field-display class="col-12"
                                    [formFieldConfig]="patientDataFields.gender"></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              *ngIf="patientDataFields.age"
              class="col-12"
              [formFieldConfig]="patientDataFields.age"
            ></app-form-field-display>
            <app-form-field-display
              *ngIf="patientDataFields.dateOfBirth"
              class="col-12"
              [value]="dateOfBirthValue"
              [label]="patientDataFields.dateOfBirth.label"
              [infoText]="'analysisDateOfBirthAgeCalculatedInfo'"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display [label]="labelStart" [value]="ecgAnalysis.startTime | appLocalDateTime"
                                    class="col-6"></app-form-field-display>
          </div>

          <div class="row">
            <app-form-field-display
              [formFieldConfig]="patientDataFields.reasonForStudy"
              [displayHorizontal]="false"
              class="col-12"
            ></app-form-field-display>
          </div>
          <div class="row" *ngIf="isEcgHolterOrAtrialFibrillation()">
            <app-form-field-display [formFieldConfig]="patientDataFields.diary" [displayHorizontal]="false"
                                    class="col-12"></app-form-field-display>
          </div>

          <div class="row" *ngIf="!isEcgHolterOrAtrialFibrillation()">
            <app-ecg-symptom-descriptions [ecgSymptoms]="ecgAnalysis.patientData.symptoms">
            </app-ecg-symptom-descriptions>
          </div>

          <div class="row">
            <app-form-field-display
              [formFieldConfig]="patientDataFields.patientFeedback"
              [displayHorizontal]="false"
              class="col-12"
            ></app-form-field-display>
          </div>
        </div>

        <div class="container" data-testId="manual-ecg-data-form" *ngIf="shouldShowManualEcgDataForm()">

          <app-ecg-preanalysis-data
            [formModel]="ecgPreanalysisFormModel"
            [formValidator]="ecgPreanalysisDataValidator"
          ></app-ecg-preanalysis-data>

          <action-button
            [testId]="'finish-preanalysis-button'"
            buttonClass="btn btn-primary"
            buttonLabel="analysisLabelButtonFinish"
            (buttonClick)="finishPreAnalysis()"
            [actionInProgress]="finishPreAnalysisInProgress"
          >
          </action-button>
        </div>

        <div id="analysisForm" *ngIf="shouldShowAnalysisForm()">
          <form class="container form-striped">
            <app-patient-status-comments-generator
              [analysisGenerationConfig]="ecgAnalysis.analysisGenerationConfig"
              (onGenerate)="setPatientStatusComments($event)"
              [config]="ecgFindingsFormConfig.patientStatusComments"
              [isInitiallyManualMode]="!!ecgAnalysis.doctorFindings.patientStatusComments"
              [measurementType]="ecgAnalysis.type"
            >
              <form-field [config]="ecgFindingsFormConfig.patientStatusComments"></form-field>
            </app-patient-status-comments-generator>

            <app-findings-generator
              [config]="ecgFindingsFormConfig.findings"
              [analysisGenerationConfig]="ecgAnalysis.analysisGenerationConfig"
              (onGenerate)="setFindings($event)"
              [measurementId]="ecgAnalysis.id"
              [isInitiallyManualMode]="!!ecgAnalysis.doctorFindings.findings"
              [preanalysisEcgData]="ecgAnalysis.preanalysisEcgData"
              [fullPreanalysisEcgData]="ecgAnalysis.fullPreanalysisEcgData"
              [measurementType]="ecgAnalysis.type"
              [externalAnalysisType]="ecgAnalysis.externalAnalysisType"
            >
              <form-field [config]="ecgFindingsFormConfig.findings"></form-field>
            </app-findings-generator>

            <div
              *ngIf="ecgAnalysis.type === 'SYMPTOM_HOLTER'"
              data-testId="ecg-symptom-section"
            >
              <div>{{ "ecgAnalysisSymptomsSectionTitle" | localize }}</div>
              <div *ngFor="let analysis of ecgSymptomAnalyses;">
                {{ analysis.ecgSymptomDescription }}
              </div>

              <form-field
                [config]="ecgFindingsFormConfig.symptomsComment"
              ></form-field>
            </div>

            <form-field [config]="ecgFindingsFormConfig.conclusion"></form-field>

            <app-diagnosis-generator
              [config]="ecgFindingsFormConfig.diagnosis"
              [analysisGenerationConfig]="ecgAnalysis.analysisGenerationConfig"
              (onGenerate)="setDiagnosis($event)"
              [isInitiallyManualMode]="!!ecgAnalysis.doctorFindings.diagnosis"
            >
              <form-field [config]="ecgFindingsFormConfig.diagnosis"></form-field>
            </app-diagnosis-generator>

          </form>

          <div id="samplesAndPreview" *ngIf="shouldShowSamplesAndPreview()">
            <div class="pt-2">
              <action-button
                type="button"
                class="btn btn-link mt-2"
                (click)="previewEcgReport()"
                [testId]="'preview-button'"
                [buttonLabel]="labelPreviewEcgReport"
                [actionInProgress]="previewInProgress"
              >
              </action-button>
            </div>
          </div>
        </div>

        <div id="saveAndFinish" *ngIf="shouldShowSaveAndFinishButtons()">
          <div class="pt-4">
            <button *ngIf="!isFinishMode" type="button" class="btn btn-primary me-4" (click)="switchToFinishMode()" data-testid="finish-mode-button">
              {{ labelButtonFinish | localize }}<i class="fa fa-chevron-right mx-1"></i>
            </button>

            <action-button
              *ngIf="!isFinishMode"
              class="me-4"
              buttonClass="btn btn-outline-primary"
              [buttonLabel]="labelSave"
              [actionInProgressLabel]="labelInProgress"
              (buttonClick)="onSaveButtonClick()"
              [actionInProgress]="saveInProgress$ | async"
              [testId]="'save-analysis-button'"
            >
            </action-button>

            <action-button
              *ngIf="isFinishMode"
              class="me-4"
              buttonClass="btn btn-primary"
              [buttonLabel]="labelButtonFinishConfirm"
              [actionInProgressLabel]="labelButtonFinishInProgress"
              (buttonClick)="onFinishAnalysisClick()"
              [actionInProgress]="finishAnalysisInProgress$ | async"
              [testId]="'confirm-finish-analysis-button'"
            >
            </action-button>
            <button *ngIf="isFinishMode" type="button" class="btn btn-secondary" (click)="switchToSaveMode()">
              {{ labelButtonFinishCancel | localize }}
            </button>
            <span *ngIf="!!errorMessage" class="alert alert-danger ms-4">{{ errorMessage | localize }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="h-100 col-md-6 col-md">

      <div *ngIf="!isTechnicianAnalysisOnly()"
           class="my-1 d-flex">
        <div>
          <button
            class="btn btn-sm btn-outline-primary mx-1"
            [ngClass]="{active: patientDataDisplayed}"
            data-testId="show-patient-data-button"
            (click)="showPatientData()"
          >
            {{ localizationKey("analysisDisplayPatientDataButton") | localize }}
          </button>

          <button
            class="btn btn-sm btn-outline-primary"
            [ngClass]="{active: !patientDataDisplayed}"
            data-testId="show-samples-report-button"
            (click)="showSamplesReport()"
          >
            {{ localizationKey("analysisDisplaySamplesReportButton") | localize }}
          </button>

          <action-button
            *ngIf="feature513Released && shouldShowSamplesReportPanel()"
            [buttonClass]="'btn btn-sm btn-secondary mx-1'"
            [iconClass]="'fa fa-refresh'"
            [testId]="'refresh-samples-report-button'"
            [actionInProgress]="gettingSamplesReportInProgress"
            (buttonClick)="refreshSamplesReport()"
            [toolTip]="'analysisEcgRefreshSamplesReportLabel'"
          >
          </action-button>
        </div>

        <button
          *ngIf="feature509Released && samplesReportPdfUrl !== undefined"
          class="btn btn-sm btn-outline-primary ms-auto"
          data-testId="open-samples-report-in-new-tab-button"
          (click)="openSamplesReportInNewTab()"
        >
          {{ localizationKey("analysisDisplaySamplesReportButton") | localize }}
          <i class="fa fa-external-link"></i>
        </button>
      </div>


      <div
        class="h-95"
        *ngIf="shouldShowSamplesReportPanel()"
        data-testId="samples-not-available-message"
      >
        <iframe
          data-testId="samples-report"
          *ngIf="samplesReportPdfUrl !== undefined"
          [src]="samplesReportPdfUrl!.sanitizedUrl"
          class="pdf-viewer"
        >
        </iframe>
        <div *ngIf="samplesReportPdfUrl === undefined">
          {{ localizationKey("analysisDisplaySamplesReportNotAvailable") | localize }}
        </div>
      </div>

      <div class="h-95 overflow-auto"
           *ngIf="patientDataDisplayed && patientDataFields && ecgAnalysis && !isTechnicianAnalysisOnly()">
        <div
          id="patientDataPanel"
          data-testId="patient-data-panel"
          class="col-12 small form-grid form-grid-striped"
        >
          <app-basic-patient-data-display [patientDataFields]="patientDataFields"></app-basic-patient-data-display>
          <div class="row">
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.smoking"></app-form-field-display>
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.abnormalHeartbeats"></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.slowPulse"></app-form-field-display>
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.fastPulse"></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.palpitation"></app-form-field-display>
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.irregularPulse"></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.dizziness"></app-form-field-display>
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.lossOfConsciousness"></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.blackouts"></app-form-field-display>
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.chestPain"></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display class="col-6"
                                    [formFieldConfig]="patientDataFields.shortnessOfBreath"></app-form-field-display>
            <app-form-field-display [label]="labelStart" [value]="ecgAnalysis.startTime | appLocalDateTime"
                                    class="col-6"></app-form-field-display>
          </div>

          <div class="row">
            <app-form-field-display
              class="col-12"
              [formFieldConfig]="patientDataFields.diagnosedHeartDisease"
              [displayHorizontal]="false"
            ></app-form-field-display>
          </div>

          <div class="row">
            <app-form-field-display
              class="col-12"
              [formFieldConfig]="patientDataFields.currentMedication"
              [displayHorizontal]="false"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              [formFieldConfig]="patientDataFields.reasonForStudy"
              [displayHorizontal]="false"
              class="col-12"
            ></app-form-field-display>
          </div>
          <div class="row" *ngIf="isEcgHolterOrAtrialFibrillation()">
            <app-form-field-display [formFieldConfig]="patientDataFields.diary" [displayHorizontal]="false"
                                    class="col-12"></app-form-field-display>
          </div>
          <div class="row" *ngIf="!isEcgHolterOrAtrialFibrillation() && feature524Released">
            <app-ecg-symptom-descriptions [ecgSymptoms]="ecgAnalysis.patientData.symptoms">
            </app-ecg-symptom-descriptions>
          </div>
          <div class="row">
            <app-form-field-display
              [formFieldConfig]="patientDataFields.patientFeedback"
              [displayHorizontal]="false"
              class="col-12"
            ></app-form-field-display>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <button
          *ngIf="ecgAnalysis"
          type="button"
          [ngClass]="'btn btn-sm me-4 mb-1 ' + getButtonType()"
          data-testid="show-comments-button"
          (click)="onShowCommentsClick()"
          [title]="getCommentButtonLabel('measurementsGridButtonLabelShowComments' | localize, ecgAnalysis.commentsCount!)"
        >
          <i class="fa fa-comment me-1"></i>
          <b>{{ String(ecgAnalysis.commentsCount || "0") }}</b>
        </button>
      </div>
    </div>
  </div>
</div>


<ng-template #templateComments>
  <app-comments
    [measurementId]="ecgAnalysis!.id"
    [code]="ecgAnalysis!.code"
    [hospitalName]="ecgAnalysis!.hospitalName"
    (commentsCountChanged)="onCommentsCountChanged($event)"
    (close)="modalRefComments?.hide()"
  >
  </app-comments>
</ng-template>
